import { RecurringWorkspaceItem, VideoType, WorkspaceMember } from 'Shared/constants/types';

export enum ItemType {
  discussionTopic = 'discussion_topic',
  actionItem = 'action_item',
}

export type MeetingItem = {
  id: number;
  uuid: string;
  body: string;
  isHighPriority: boolean;
  position: number;
  completed: boolean;
  assignmentId: number;
  assignmentPersonId: number;
  itemType: string;
  recurringWorkspaceItem: RecurringWorkspaceItem;
  positionForActionItemsPage: number;
  attachments?: Array<{
    id: number;
  }>;
  assignee: {
    userId: number;
  };
  comments: Array<{}>;
  video: VideoType;
  parentUuid: string;
  parentText: string;
  isShowLoader: boolean;
  parentId: number;
  showPreview: boolean;
  user: WorkspaceMember;
  workspaceId: string;
  workspacePath: string;
  workspaceName: string;
  dueBy: number;
  goalSlug: string;
  createdAt: Date;
  asanaData?: {
    url: string;
    taskId: string;
  };
  commentsCount: number;
};
